import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  profitabilityComponentsTableTypeName,
  getProfitabilityComponentsTableHeader,
  profitabilityComponentsTableRowStyle,
} from "../../../constants";
import { getData } from "../../../../../services";
import { ProfitabilityComponents } from "../../../../../components/parts";

export const ProfitabilityComponent = ({ buildingId, complexId }) => {
  const [tableBody, setTableBody] = useState([]);
  const { user } = useSelector((state) => state.auth);

  let title = `Portfolio Revenues Components`;
  let url = `/praas/v1/buildings/profitability-components/`;

  if (buildingId) {
    url = `/praas/v2/buildings/${buildingId}/properties/profitability-components/`;
  } else if (complexId) {
    title = `Complex Profitability Components`;
    url = `/praas/v2/complexes/${complexId}/properties/profitability-components/`;
  }

  useEffect(() => {
    getData(url, (data) => {
      const results = [];
      for (const [key, value] of Object.entries(data)) {
        results.push({
          type: profitabilityComponentsTableTypeName[key],
          rowStyles: profitabilityComponentsTableRowStyle[key],
          ...value,
        });
      }
      setTableBody(results);
    });
  }, [buildingId, complexId]);

  return (
    <ProfitabilityComponents
      title={title}
      tableHeader={getProfitabilityComponentsTableHeader(user.unit_system)}
      tableBody={tableBody}
    />
  );
};
